import root from 'window-or-global'

import { isCountryUS } from '@src/authorisation/helpers'
import {
  consumerGroupIsNotGraduate,
  consumerGroupIsNotStudentOrGraduate,
  consumerGroupIsStudent
} from '@src/helpers'
import {
  ROUTES,
  VERIFICATION_METHOD_PAGES
} from '@src/verification/children/router/constants'
import { getUrlFromManifest } from '@src/verification/helpers'

const { ROOT, PAGES } = ROUTES.CLIENT

function scrollToTop() {
  root.document.documentElement.scrollTop = 0
}

export function getPageUrl(props, url) {
  return url.replace(':country', props.params.country)
}

export function navigateToUrl(props, url) {
  props.router.push(getPageUrl(props, url))

  scrollToTop()
}

export function getInstitutionPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.INSTITUTION.ROOT}`)
}

export function navigateToInstitutionPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.INSTITUTION.ROOT}`)
}

export function getInstitutionSupportUrl(props) {
  return getPageUrl(
    props,
    `${ROOT}${PAGES.INSTITUTION.ROOT}${PAGES.INSTITUTION.SUPPORT}`
  )
}

export function navigateToInstitutionSupportPage(props) {
  navigateToUrl(
    props,
    `${ROOT}${PAGES.INSTITUTION.ROOT}${PAGES.INSTITUTION.SUPPORT}`
  )
}

export function getMethodsPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.METHODS}`)
}

export function navigateToMethodsPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.METHODS}`)
}

export function getPortalPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.PORTAL.ROOT}`)
}

export function navigateToPortalPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.PORTAL.ROOT}`)
}

export function getPortalErrorPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.PORTAL.ROOT}${PAGES.PORTAL.ERROR}`)
}

export function navigateToPortalErrorPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.PORTAL.ROOT}${PAGES.PORTAL.ERROR}`)
}

export function getEmailPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.EMAIL.ROOT}`)
}

export function navigateToEmailPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.EMAIL.ROOT}`)
}

export function getEmailSentPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.EMAIL.ROOT}${PAGES.EMAIL.SENT}`)
}

export function navigateToEmailSentPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.EMAIL.ROOT}${PAGES.EMAIL.SENT}`)
}

export function getEmailSupportUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.EMAIL.ROOT}${PAGES.EMAIL.SUPPORT}`)
}

export function navigateToEmailSupportPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.EMAIL.ROOT}${PAGES.EMAIL.SUPPORT}`)
}

export function navigateToEmailInboundPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.EMAIL.ROOT}${PAGES.EMAIL.INBOUND}`)
}

export function getManualPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.MANUAL.ROOT}`)
}

export function navigateToManualPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.MANUAL.ROOT}`)
}

export function getManualUploadPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.MANUAL.ROOT}${PAGES.MANUAL.UPLOAD}`)
}

export function navigateToManualUploadPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.MANUAL.ROOT}${PAGES.MANUAL.UPLOAD}`)
}

export function getManualSentPageUrl(props) {
  return getPageUrl(props, `${ROOT}${PAGES.MANUAL.ROOT}${PAGES.MANUAL.SENT}`)
}

export function navigateToManualSentPage(props) {
  navigateToUrl(props, `${ROOT}${PAGES.MANUAL.ROOT}${PAGES.MANUAL.SENT}`)
}

export const navigateToSuccessPage = (props) => {
  navigateToUrl(props, `${ROOT}${PAGES.SUCCESS.ROOT}`)
}

export function redirectToPassthroughUrl(props) {
  window.location.href = getUrlFromManifest(ROUTES.SERVER.PASSTHROUGH)
}

export function redirectBackToUrl(backToUrl) {
  window.location.href = backToUrl
}

export const canUserGraduate = (consumerGroup, eligableForInferredGraduate) =>
  !consumerGroupIsNotGraduate(consumerGroup) && eligableForInferredGraduate

export const navigateToCountryPage = (props) => {
  navigateToUrl(props, `${ROOT}${PAGES.COUNTRY.ROOT}`)
}

export const continueThroughVerificationJourney = (props) => {
  navigateToUrl(props, ROOT)
}

export function getRootPage(props) {
  const {
    consumerGroup,
    eligableForInferredGraduate,
    expiredStudent,
    closedConsumerGroupVerificationData,
    institution,
    manualVerificationPending
  } = props

  if (shouldDefaultToContryPage(consumerGroup)) {
    return PAGES.COUNTRY.ROOT
  }

  if (consumerGroupIsNotStudentOrGraduate(consumerGroup)) {
    if (
      shouldSetInstituition(closedConsumerGroupVerificationData, institution)
    ) {
      return PAGES.INSTITUTION.ROOT
    }

    const primaryVerificationMethod = getPrimaryVerificationMethod(
      closedConsumerGroupVerificationData,
      institution
    )
    return VERIFICATION_METHOD_PAGES[primaryVerificationMethod]
  }

  if (canUserGraduate(consumerGroup, eligableForInferredGraduate)) {
    return PAGES.GRADUATION.ROOT
  }

  if (expiredStudent && !manualVerificationPending) return PAGES.EXPIRED

  if (expiredStudent && manualVerificationPending)
    return `${PAGES.MANUAL.ROOT + PAGES.MANUAL.SENT}`

  if (!consumerGroupIsNotGraduate(consumerGroup)) return PAGES.COUNTRY.ROOT

  return PAGES.EMAIL.ROOT
}

export const getPrimaryVerificationMethod = (
  closedConsumerGroupVerificationData,
  institution
) => {
  return institution
    ? institution?.verificationMethods[0]
    : closedConsumerGroupVerificationData.verificationMethods[0]
}

export const shouldSetInstituition = (
  closedConsumerGroupVerificationData,
  institution
) => {
  return closedConsumerGroupVerificationData.institutionRequired && !institution
}

export const getVerificationRedirectUrl = (props, location, params) => {
  const verificationRoot = `/${params.country}/verification`
  const redirectPage = getRootPage(props)
  const queryString = location.search

  return verificationRoot + redirectPage + queryString
}

export const redirectToPassthroughUrlWithParams = (params) => {
  window.location.href = getUrlFromManifest(ROUTES.SERVER.PASSTHROUGH) + params
}

export const shouldDefaultToContryPage = (consumerGroup) => {
  return (
    isCountryUS() &&
    consumerGroupIsStudent(consumerGroup) &&
    !!process.env.MEASUREONE_TESTS_ENABLED
  )
}

export const shouldRenderCountryRoute = (consumerGroup) => {
  return (
    shouldDefaultToContryPage(consumerGroup) || consumerGroup === 'graduate'
  )
}
